import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[appSelectAllOnClick]'
})
export class SelectAllOnClickDirective {
  
  constructor(private el: ElementRef) {}
  
  @HostListener('click', ['$event'])
  onClick(event: MouseEvent) {
    const input = this.el.nativeElement as HTMLInputElement;
    
    // Solo aplicamos a elementos input de tipo texto, número, etc.
    if (input.tagName.toLowerCase() === 'input') {
      input.select();
      
      // Prevenir la propagación para evitar problemas en aplicaciones complejas
      event.stopPropagation();
    }
  }
  
  @HostListener('focus', ['$event'])
  onFocus(event: FocusEvent) {
    const input = this.el.nativeElement as HTMLInputElement;
    
    // Solo aplicamos a elementos input de tipo texto, número, etc.
    if (input.tagName.toLowerCase() === 'input') {
      input.select();
    }
  }
}